(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lac-language-flags"] && !Shopify.designMode) return;
  try {
    // Close the flag list on a click outside it or on Escape (<details> does not do this by itself).
  // Capture phase, because some theme components stop click propagation.
  document.addEventListener('click', (event) => {
    for (const details of document.querySelectorAll('.lac-language-flags[open]')) {
      if (!details.contains(event.target)) details.open = false;
    }
  }, true);
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    for (const details of document.querySelectorAll('.lac-language-flags[open]')) {
      details.open = false;
      details.querySelector('summary')?.focus();
    }
  });
  } catch(e) { console.error(e); }
})();

})();
